import React from 'react'
import { Empty, Spin } from 'antd'
import { isEmpty } from 'underscore'
import { ChartBox } from '../../../../ResultPanel/component/ChartBox'
import styles from '../../Layout/AnalyticsLayout.module.scss'
import ErrorDisplay from "../../ErrorDisplay";

interface HistogramChartProps {
  histogramImage: string
  histogramLinks: string[]
  pointName: string
  isLoading: boolean
  error: string
  isOfflineDataset: boolean

}

export default function HistogramChart({
   histogramImage,
   histogramLinks,
   pointName,
   isLoading,
   error,
   isOfflineDataset
 }: HistogramChartProps) {
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        minHeight: '400px'
      }}>
        <Spin size="large" />
      </div>
    )
  }

  if (isOfflineDataset) {
    return <ErrorDisplay isOfflineDataset={isOfflineDataset}/>
  }
  return (
    <div id="Analytics-Histogram-Plot" className={styles.chartPointWrapper}>
      <ChartBox
        key="Histogram (w. Weibull Parameters)"
        title="Histogram (w. Weibull Parameters)"
        height={isLoading || !isEmpty(error) ? '50px' : 'auto'}
        plot={
          isLoading ? (
            <div className={styles.spinner}>
              <Spin size="large" />
            </div>
          ) : !isEmpty(error) && !error.includes('Cmems error') ? (
            <div>{error}</div>
          ) : histogramImage ? (
            <img
              style={{
                width: '80%',
                objectFit: 'scale-down',
                maxHeight: '55vh',
                display: 'block',
                margin: '0 auto'
              }}
              src={histogramImage}
              alt="Histogram"
            />
          ) : <Empty description={error.includes('Cmems error') ? "Layer not available" : "No data available"} />
        }
        dataset=""
        link={histogramLinks}
      />
    </div>
  )
}
